module.exports = __webpack_public_path__ + "img/armhole length front.f14bf77c.png";